import React from 'react';
import ReactDOM from 'react-dom';

/* ── Animated Fill Icons ── */

export const WaterFillIcon = ({ pct = 0, size = 60 }) => {
  const fill = Math.max(0, Math.min(100, pct));
  const fillH = (fill / 100) * 32;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <defs>
        <clipPath id="water-drop"><path d="M24 4 C24 4 10 22 10 30 C10 38 16.3 44 24 44 C31.7 44 38 38 38 30 C38 22 24 4 24 4Z" /></clipPath>
      </defs>
      {/* Outline */}
      <path d="M24 4 C24 4 10 22 10 30 C10 38 16.3 44 24 44 C31.7 44 38 38 38 30 C38 22 24 4 24 4Z"
        stroke="#4A90D9" strokeWidth="2" fill="none" opacity="0.25" />
      {/* Fill */}
      <g clipPath="url(#water-drop)">
        <rect x="8" y={44 - fillH} width="32" height={fillH}
          fill="#4A90D9" opacity="0.65"
          style={{ transition: 'y 0.6s ease-in-out, height 0.6s ease-in-out' }} />
        {fill > 5 && (
          <path d={`M8 ${44 - fillH + 2} Q16 ${44 - fillH - 1} 24 ${44 - fillH + 2} Q32 ${44 - fillH + 5} 40 ${44 - fillH + 2}`}
            fill="#4A90D9" opacity="0.45"
            style={{ transition: 'd 0.6s ease-in-out' }} />
        )}
      </g>
    </svg>
  );
};

export const RecoveryFillIcon = ({ pct = 0, size = 60 }) => {
  const fill = Math.max(0, Math.min(100, pct));
  const fillH = (fill / 100) * 20;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <defs>
        <clipPath id="cup-body"><rect x="12" y="14" width="24" height="22" rx="4" /></clipPath>
      </defs>
      {/* Cup body outline */}
      <rect x="12" y="14" width="24" height="22" rx="4" stroke="#2EAA6F" strokeWidth="2" fill="none" opacity="0.25" />
      {/* Handle */}
      <path d="M36 20 C40 20 42 24 40 28 C39 30 36 30 36 28" stroke="#2EAA6F" strokeWidth="2" fill="none" opacity="0.25" />
      {/* Saucer */}
      <ellipse cx="24" cy="40" rx="14" ry="2.5" stroke="#2EAA6F" strokeWidth="1.5" fill="none" opacity="0.2" />
      {/* Fill */}
      <g clipPath="url(#cup-body)">
        <rect x="10" y={36 - fillH} width="28" height={fillH}
          fill="#2EAA6F" opacity="0.55"
          style={{ transition: 'y 0.6s ease-in-out, height 0.6s ease-in-out' }} />
      </g>
      {/* Steam */}
      {fill > 70 && (
        <g opacity="0.3">
          <path d="M20 12 Q20 8 21 6" stroke="#2EAA6F" strokeWidth="1.5" strokeLinecap="round" fill="none" />
          <path d="M24 11 Q24 7 25 5" stroke="#2EAA6F" strokeWidth="1.5" strokeLinecap="round" fill="none" />
          <path d="M28 12 Q28 8 29 6" stroke="#2EAA6F" strokeWidth="1.5" strokeLinecap="round" fill="none" />
        </g>
      )}
    </svg>
  );
};

export const SleepFillIcon = ({ pct = 0, size = 60 }) => {
  const fill = Math.max(0, Math.min(100, pct));
  const fillH = (fill / 100) * 32;
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <defs>
        <clipPath id="moon-clip"><path d="M30 6 C18 8 10 18 10 30 C10 38 17 44 26 44 C35 44 42 38 42 30 C42 20 38 12 30 6 Z" /></clipPath>
      </defs>
      {/* Moon outline */}
      <path d="M30 6 C18 8 10 18 10 30 C10 38 17 44 26 44 C35 44 42 38 42 30 C42 20 38 12 30 6 Z"
        stroke="#8B7EC8" strokeWidth="2" fill="none" opacity="0.25" />
      {/* Fill */}
      <g clipPath="url(#moon-clip)">
        <rect x="8" y={46 - fillH} width="36" height={fillH}
          fill="#8B7EC8" opacity="0.5"
          style={{ transition: 'y 0.6s ease-in-out, height 0.6s ease-in-out' }} />
      </g>
      {fill === 0 && (
        <g opacity="0.15">
          <circle cx="22" cy="22" r="1.5" fill="#8B7EC8" />
          <circle cx="30" cy="28" r="1" fill="#8B7EC8" />
          <circle cx="18" cy="32" r="1" fill="#8B7EC8" />
        </g>
      )}
    </svg>
  );
};

export const WeightIcon = ({ size = 60 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <rect x="8" y="18" width="32" height="22" rx="4" stroke="#C67A5C" strokeWidth="2" fill="none" opacity="0.35" />
    <circle cx="24" cy="29" r="8" stroke="#C67A5C" strokeWidth="1.5" fill="none" opacity="0.25" />
    <path d="M24 22 L24 29 L29 26" stroke="#C67A5C" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.45" />
    <path d="M16 18 L18 10 L30 10 L32 18" stroke="#C67A5C" strokeWidth="2" fill="none" opacity="0.35" strokeLinejoin="round" />
  </svg>
);

export const ActivityIcon = ({ logged = false, size = 60 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    {/* Dumbbell */}
    <rect x="10" y="20" width="8" height="10" rx="2" stroke="#4A8FE7" strokeWidth="2" fill={logged ? '#4A8FE720' : 'none'} opacity={logged ? 1 : 0.35} />
    <rect x="30" y="20" width="8" height="10" rx="2" stroke="#4A8FE7" strokeWidth="2" fill={logged ? '#4A8FE720' : 'none'} opacity={logged ? 1 : 0.35} />
    <line x1="18" y1="25" x2="30" y2="25" stroke="#4A8FE7" strokeWidth="2.5" opacity={logged ? 0.6 : 0.3} strokeLinecap="round" />
    <line x1="6" y1="25" x2="10" y2="25" stroke="#4A8FE7" strokeWidth="2" opacity={logged ? 0.5 : 0.25} strokeLinecap="round" />
    <line x1="38" y1="25" x2="42" y2="25" stroke="#4A8FE7" strokeWidth="2" opacity={logged ? 0.5 : 0.25} strokeLinecap="round" />
    {logged && (
      <circle cx="38" cy="12" r="6" fill="#4A8FE7" opacity="0.8">
        <animate attributeName="r" values="5;6;5" dur="2s" repeatCount="indefinite" />
      </circle>
    )}
    {logged && <path d="M35.5 12 L37.5 14 L41 10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />}
  </svg>
);

export const MoodIcon = ({ emoji, size = 60 }) => {
  if (emoji) {
    return (
      <div style={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.6 }}>
        {emoji}
      </div>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="16" stroke="#E8A54B" strokeWidth="2" fill="none" opacity="0.3" />
      <circle cx="19" cy="21" r="1.5" fill="#E8A54B" opacity="0.4" />
      <circle cx="29" cy="21" r="1.5" fill="#E8A54B" opacity="0.4" />
      <path d="M18 28 Q24 33 30 28" stroke="#E8A54B" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.35" />
    </svg>
  );
};

/**
 * Premium Health Card with card styling, animated fill icons,
 * and smooth interaction states.
 */
export function HealthCard({
  testId, icon: Icon, iconColor, iconBg, title, subtitle, subtitleColor,
  onClick, children,
  // New props for animated icons
  fillIcon, fillPct, iconSize = 60,
}) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        padding: 16, cursor: 'pointer', textAlign: 'center', width: '100%',
        background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.04)',
        borderRadius: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        WebkitTapHighlightColor: 'transparent',
      }}
      onMouseDown={e => { e.currentTarget.style.transform = 'scale(0.97)'; e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)'; }}
      onMouseUp={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
      onTouchStart={e => { e.currentTarget.style.transform = 'scale(0.97)'; }}
      onTouchEnd={e => { setTimeout(() => { if (e.currentTarget) e.currentTarget.style.transform = 'scale(1)'; }, 100); }}
    >
      {/* Icon area */}
      <div style={{ marginBottom: 8, flexShrink: 0, lineHeight: 0 }}>
        {fillIcon || (
          <div style={{
            width: iconSize, height: iconSize, borderRadius: 16,
            background: iconBg || `${iconColor}12`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon style={{ width: iconSize * 0.4, height: iconSize * 0.4, color: iconColor }} />
          </div>
        )}
      </div>
      <p style={{ fontSize: 14, fontWeight: 700, margin: 0, color: '#1A1A18', fontFamily: "'DM Sans', sans-serif" }}>
        {title}
      </p>
      {children || (
        <p style={{ fontSize: 12, margin: '3px 0 0', color: subtitleColor || '#9A9590', fontFamily: "'DM Sans', sans-serif" }}>
          {subtitle}
        </p>
      )}
    </button>
  );
}
